import {Box, Button, List, ListItemText, Typography} from '@mui/material';
import React from 'react';

import {Modal} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {StyledDialogContent, StyledListItem, StyledListSubheader} from './styles';
import {GracePeriodDetailsProps} from './types';

const {onGoingGrace, planGracePeriod, specialtiesListInGracePeriod} =
	translations['pt-br'].privateFlow.home;
const {close} = translations['pt-br'].commons;

export function GracePeriodDetailsModal({dateDue, endsIn, open, setOpen}: GracePeriodDetailsProps) {
	function handleClose() {
		setOpen(false);
	}

	return (
		<Modal.Root fullScreen={false} open={open} onClose={() => setOpen(false)}>
			<Modal.Header onClose={() => setOpen(false)} title={onGoingGrace} />
			<StyledDialogContent>
				<StyledListSubheader>{planGracePeriod}</StyledListSubheader>
				<Typography variant="h6" color="primary">
					{dateDue}
					<Typography fontSize={14} color="text.secondary">
						{endsIn}
					</Typography>
				</Typography>
				<Box marginTop={2}>
					<List
						disablePadding
						subheader={
							<StyledListSubheader>
								{specialtiesListInGracePeriod}
							</StyledListSubheader>
						}>
						<StyledListItem divider>
							<ListItemText primary="Acupuntura" />
						</StyledListItem>
						<StyledListItem divider>
							<ListItemText primary="Alergologia" />
						</StyledListItem>
						<StyledListItem divider>
							<ListItemText primary="Neuropediatria" />
						</StyledListItem>
						<StyledListItem>
							<ListItemText primary="Oncologia Clínica/Quimioterapia" />
						</StyledListItem>
					</List>
				</Box>
			</StyledDialogContent>
			<Modal.Footer>
				<Button fullWidth onClick={handleClose}>
					{close}
				</Button>
			</Modal.Footer>
		</Modal.Root>
	);
}
